import {useState} from "react";
import {actions} from "../../store";

export const useAutoAttendantsListLogic = (dispatch:any) => {

    const [callHistoryModalConfig, setCallHistoryModalConfig] = useState<{
        accountId: number;
        name?: string;
    }>();

    const [removeModal, setRemoveModal] = useState<{
        isOpen: boolean;
        name?: string;
        id?: string;
        i_customer?: number;
    }>();

    const showCallHistory = (accountId: number, name?: string) =>
        setCallHistoryModalConfig({ accountId, name });

    const showRemoveExtensionModal = (
        id: string,
        i_customer: number,
        i_c_ext?: number,
        name?: string,
    ) => setRemoveModal({ isOpen: true, id, name, i_customer });

    const closeRemoveDialog = () => setRemoveModal((prev) => ({ ...prev, isOpen: false }));
    const resetCallHistoryDialog = () => setCallHistoryModalConfig(undefined);

    const deleteExtension = () => {
        if (removeModal?.id && removeModal?.i_customer) {
            dispatch(
                actions.deleteCustomerAutoAttendant.request({
                    id: removeModal.id,
                    i_customer: removeModal.i_customer,
                }),
            );
            closeRemoveDialog();
        }
    };

    return {
        callHistoryModalConfig,
        showCallHistory,
        resetCallHistoryDialog,
        removeModal,
        showRemoveExtensionModal,
        closeRemoveDialog,
        deleteExtension,
    };
};
